//import * as React from "react";

export function Progress({ value = 0, className = "" }) {
  return (
    <div className={`w-full bg-gray-200 rounded-full ${className}`}>
      <div
        className="h-2 bg-[#12BB81] rounded-full transition-all duration-300"
        style={{ width: `${value}%` }}
      />
    </div>
  );
}
